<template>
    <form
        class="flex flex-wrap border border-gray-200 rounded py-3 px-4"
        @submit.prevent="saveRole"
    >
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel class="w-full" for="name" value="Name" />
                    <Input
                        id="name"
                        v-model="form.name"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.name }"
                    />
                    <InputError :message="form.errors.name" class="mt-2" />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="guard_name"
                        value="Guard Name"
                    />
                    <Input
                        id="guard_name"
                        v-model="form.guard_name"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.guard_name }"
                    />
                    <InputError
                        :message="form.errors.guard_name"
                        class="mt-2"
                    />
                </div>
            </div>
        </div>
        <div class="lg:w-full md:w-full">
            <div class="flex flex-col mb-6">
                <div class="w-full px-3 text-center">
                    <InertiaButtonEdit
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Data"
                        v-if="form.id"
                    />
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Baru"
                        v-else
                    />
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { defineComponent } from "vue";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import Select from "@/Components/Select";
import Alert from "@/Components/Alert";

import InputDataGrid from "@/Components/InputDataGrid";

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        Select,
        Alert,
        InputDataGrid,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                name: null,
                guard_name: null,
            }),
        };
    },
    mounted() {
        //
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
    },
    methods: {
        addItem: function () {
            //
        },
        populateEdit: function (role) {
            this.form.id = role.id;
            this.form.name = role.name;
            this.form.guard_name = role.guard_name;
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.name = null;
            this.form.guard_name = null;
            // this.form.reset();
            this.form.clearErrors();
        },
        saveRole: function (event) {
            let self = this;
            this.form.post(route("role.store"), {
                errorBag: "saveRole",
                preserveScroll: true,
                onSuccess: () => {
                    if (self.form.id) {
                        self.$emit("changeData", self.form);
                    } else {
                        self.$emit("loadData");
                        // self.$emit('addData', self.form);
                        self.resetForm();
                    }
                },
                onFinish: () => {
                    //
                },
            });
        },
    },
});
</script>